import { useCallback, useEffect, useState } from "react";
import { MessageSquare, X } from "lucide-react";
import { api } from "@/lib/api";
import { ChatThread } from "@/components/ChatThread";

export const ChatBubble = () => {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [unread, setUnread] = useState(0);

  const loadThread = useCallback(() => api.get("/chat").then((r) => { setMessages(r.data); setUnread(0); }).catch(() => {}), []);

  useEffect(() => {
    if (open) {
      loadThread();
      const t = setInterval(loadThread, 5000);
      return () => clearInterval(t);
    }
    const poll = () => api.get("/chat/unread").then((r) => setUnread(r.data.unread)).catch(() => {});
    poll();
    const t = setInterval(poll, 20000);
    return () => clearInterval(t);
  }, [open, loadThread]);

  const send = async (text) => {
    const { data } = await api.post("/chat", { text });
    setMessages((m) => [...m, data]);
  };

  return (
    <>
      {open && (
        <div className="fixed z-40 bottom-24 right-4 sm:right-8 w-[calc(100vw-2rem)] sm:w-96 h-[70vh] sm:h-[520px] bg-white border border-[var(--rf-ink)] flex flex-col rf-fade" data-testid="chat-panel">
          <div className="flex items-center gap-3 px-4 h-14 border-b border-[var(--rf-ink)]">
            <span className="w-2.5 h-2.5 bg-[var(--rf-red)]" />
            <span className="font-bold text-sm">Scrivi a Reverse Frame</span>
            <button onClick={() => setOpen(false)} className="ml-auto hover:text-[var(--rf-red)]" data-testid="chat-close-button" aria-label="Chiudi"><X size={16} /></button>
          </div>
          <ChatThread messages={messages} me="user" onSend={send} className="flex-1"
            emptyText="Ciao! Hai domande o suggerimenti? Scrivici qui, ti rispondiamo appena possibile." />
        </div>
      )}
      <button onClick={() => setOpen((o) => !o)} data-testid="chat-bubble-button" aria-label="Apri chat"
        className="fixed z-40 bottom-6 right-4 sm:right-8 w-14 h-14 bg-[var(--rf-ink)] text-white grid place-items-center transition-colors duration-150 hover:bg-[var(--rf-red)]">
        {open ? <X size={20} /> : <MessageSquare size={20} />}
        {!open && unread > 0 && (
          <span className="absolute -top-1.5 -right-1.5 min-w-5 h-5 px-1 bg-[var(--rf-red)] text-white rf-mono text-[10px] grid place-items-center" data-testid="chat-unread-badge">{unread}</span>
        )}
      </button>
    </>
  );
};
